import { makeContextModule } from '@cian/react-utils';

import { type RefObject } from 'react';

export interface IElementsRefContext {
  filtersRef: RefObject<HTMLElement>;
  listingRef: RefObject<HTMLDivElement>;
  mapContainerRef: RefObject<HTMLDivElement>;
}

export const {
  Context: { Provider: ElementsRefContextProvider },
  useContext: useElementsRefContext,
} = makeContextModule<IElementsRefContext>({
  contextName: 'ElementsRefContext',
});
